<div class="calendar-component-container">
  <div
    class="attribute-editor-component"
    rvSpinner="calendar-editor-loader"
    [rvShowSpinner]="spinner"
  >
    <div class="calendar-component-settings te-scrollable-container">
      @if (!calendarType) {
        <div class="attribute-editor-row">
          <div class="row">
            <div class="col-xs-12">
              @if (authenticateFailed) {
                <div class="form-group has-error">
                  <p class="help-block">
                    <span
                      >There was an issue with authentication. Please try
                      again.</span
                    >
                  </p>
                </div>
              }
              <div class="source-container form-group">
                <h3 class="top-heading">Connect your calendar</h3>
                <label
                  >Connect a calendar to display events and room
                  bookings.</label
                >
                <button
                  matButton="outlined"
                  class="tw-w-full button-role--provider"
                  id="te-google-connect"
                  type="button"
                  (click)="selectCalendarType(PROVIDER_GOOGLE_CALENDAR)"
                >
                  <mat-icon
                    svgIcon="integration-google"
                    aria-hidden="true"
                  ></mat-icon>
                  <span>Continue with Google</span>
                </button>
                <button
                  matButton="outlined"
                  class="tw-w-full button-role--provider"
                  id="te-outlook-connect"
                  type="button"
                  (click)="selectCalendarType(PROVIDER_OUTLOOK_CALENDAR)"
                >
                  <mat-icon
                    svgIcon="integration-microsoft"
                    aria-hidden="true"
                  ></mat-icon>
                  <span>Continue with Microsoft</span>
                </button>
                <rv-divider label="or" />
                <button
                  matButton="outlined"
                  class="tw-w-full button-role--provider"
                  id="te-calendar-enter-url"
                  type="button"
                  (click)="selectCalendarType(CALENDAR_TYPE_PUBLIC)"
                >
                  <mat-icon svgIcon="link" aria-hidden="true"></mat-icon>
                  <span>Enter Public URL</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      } @else {
        <mat-menu
          #connectionOptions="matMenu"
          xPosition="before"
          role="menu"
          tabindex="-1"
        >
          <button
            type="button"
            class="playlist-item-hide"
            tabindex="-1"
            mat-menu-item
            role="menuitem"
            (click)="switchSource()"
          >
            <mat-icon
              svgIcon="switch"
              class="mr-3 small thin"
              aria-hidden="true"
            ></mat-icon>
            <span>Switch Calendar Source</span>
          </button>
          @if (canDisconnect()) {
            <rv-divider class="tw-my-[8px]" />
            <button
              type="button"
              class="playlist-item-hide"
              tabindex="-1"
              mat-menu-item
              role="menuitem"
              (click)="confirmDisconnect()"
            >
              <mat-icon
                svgIcon="unlink"
                class="mr-3 small"
                aria-hidden="true"
              ></mat-icon>
              <span>Disconnect Account</span>
            </button>
          }
        </mat-menu>

        @if (authenticateFailed) {
          <div class="attribute-editor-row">
            <div class="form-group has-error">
              <p class="help-block">
                <span
                  >There was an issue with authentication. Please try
                  again.</span
                >
              </p>
            </div>
          </div>
        }

        @if (revokeFailed) {
          <div class="attribute-editor-row">
            <div class="form-group has-error">
              <p class="help-block">
                We could not revoke your access with
                {{ revokeFailedProviderName }} at this time. We strongly
                recommend you manually revoke access in your
                {{ revokeFailedProviderName }} account.
              </p>
            </div>
          </div>
        }

        @if (USER_AUTHORIZED_PROVIDERS.includes(provider) && componentAccount) {
          <div class="attribute-editor-row tw-mb-[15px]">
            <div class="flex-row flex-wrap space-between mb-3">
              <label>Connected Account</label>
            </div>

            <div class="authenticated button-with-options-menu mt-2">
              <mat-icon
                [svgIcon]="getProviderLogo(provider)"
                [attr.aria-label]="getProviderName(provider)"
                aria-hidden="false"
              ></mat-icon>

              <div class="mx-auto u_ellipsis">
                {{ componentAccountUsername || 'account not connected' }}
              </div>

              <button
                class="btn btn-icon"
                aria-label="Options menu"
                type="button"
                [matMenuTriggerFor]="connectionOptions"
              >
                <mat-icon
                  svgIcon="more-vertical"
                  class="tw-rotate-90"
                  aria-hidden="true"
                ></mat-icon>
              </button>
            </div>
          </div>
        }

        @if (
          provider === PROVIDER_GOOGLE_CALENDAR &&
          sameAccount &&
          componentAccountUsername &&
          !isPublicUrl()
        ) {
          <div class="attribute-editor-row">
            <div
              class="form-group has-feedback"
              [ngClass]="{ 'has-error': calendarsFailed }"
            >
              <label id="te-calendar-id-label">Calendar</label>
              <multi-select-dropdown
                triggerId="te-calendar-id"
                ariaLabelledBy="te-calendar-id-label te-calendar-id"
                triggerText="Add Calendar"
                [items]="calendarDropdownItems"
                [selectedIds]="selectedCalendarIds"
                [open]="calendarPickerGoogleOpen"
                (openChange)="onGoogleCalendarDropdownOpenChange($event)"
                (selectionToggle)="toggleCalendarSelection($event)"
              ></multi-select-dropdown>
              @if (calendarsFailed) {
                <p class="help-block">
                  <span
                    >We couldn't load your calendars. Try again. If the issue
                    continues, contact support.</span
                  >
                </p>
              }
              <multi-select-pills
                [items]="selectedCalendarPillItems"
                (remove)="toggleCalendarSelection($event)"
                class="mt-2"
              ></multi-select-pills>
            </div>
          </div>
        }

        @if (
          provider === PROVIDER_GOOGLE_CALENDAR &&
          (!sameAccount || !componentAccountUsername) &&
          !isPublicUrl()
        ) {
          <div class="attribute-editor-row">
            <div class="form-group has-feedback">
              <label>Calendar</label><br />
              <multi-select-pills
                [items]="selectedCalendarPillItems"
                (remove)="toggleCalendarSelection($event)"
                class="mt-2"
              ></multi-select-pills>
            </div>
          </div>
        }

        @if (isPublicUrl()) {
          <div class="attribute-editor-row">
            <form>
              <div
                class="form-group has-feedback"
                [ngClass]="{
                  'has-error':
                    calendarUrlStatus && calendarUrlStatus !== 'VALID',
                  'has-success':
                    calendarUrlStatus && calendarUrlStatus === 'VALID',
                }"
              >
                <label for="te-calendar-source">Calendar URL</label>
                <div class="input-with-button-wrapper">
                  <input
                    type="text"
                    id="te-calendar-source"
                    name="te-calendar-source"
                    class="form-control u_ellipsis"
                    placeholder="iCal link or public URL"
                    [(ngModel)]="source"
                    (debounceEvent)="saveCalendarUrl()"
                    aria-label="Calendar URL"
                    maxlength="2048"
                    [attr.aria-invalid]="
                      calendarUrlStatus && calendarUrlStatus !== 'VALID'
                    "
                  />
                  <streamline-icon
                    *ngIf="calendarUrlStatus"
                    class="overlay-icon form-control-feedback"
                    aria-hidden="true"
                    [name]="
                      calendarUrlStatus !== 'VALID'
                        ? 'exclamation'
                        : 'checkmark'
                    "
                    width="14"
                    height="12"
                  ></streamline-icon>
                  <button
                    class="btn btn-icon"
                    aria-label="Options menu"
                    type="button"
                    [matMenuTriggerFor]="connectionOptions"
                    *ngIf="!componentAccount"
                  >
                    <mat-icon
                      svgIcon="more-vertical"
                      class="tw-rotate-90"
                      aria-hidden="true"
                    ></mat-icon>
                  </button>
                </div>

                <p class="help-block">
                  @if (calendarUrlStatus === 'INVALID') {
                    @if (getProviderFromUrl(source) === PROVIDER_ICAL) {
                      <span>
                        This iCal URL is invalid. Please ensure the URL starts
                        with <strong>https://</strong> and ends with
                        <strong>.ics</strong>.
                      </span>
                    } @else {
                      <span>
                        This calendar is invalid or not publicly accessible. To
                        fix the issue, see
                        <a
                          href="https://help.risevision.com/hc/en-us/articles/48407811260948-Show-a-Google-or-Microsoft-Calendar"
                          target="_blank"
                          rel="noopener noreferrer"
                          >this article</a
                        >.</span
                      >
                    }
                  }
                  @if (calendarUrlStatus === 'FAILED') {
                    <span>
                      Could not retrieve information for calendar {{ source }}.
                      Please try again. If you need help email
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="mailto:support@risevision.com"
                        >support&#64;risevision.com</a
                      ></span
                    >
                  }
                </p>
              </div>
            </form>
            @if (
              source &&
              calendarUrlStatus === 'VALID' &&
              provider === PROVIDER_GOOGLE_CALENDAR
            ) {
              <div>
                <a
                  [href]="googleCalendarLink()"
                  target="_blank"
                  rel="noopener noreferrer"
                  >View Calendar</a
                >
              </div>
            }
          </div>
        }

        @if (
          provider === PROVIDER_OUTLOOK_CALENDAR &&
          sameAccount &&
          componentAccountUsername &&
          !isPublicUrl()
        ) {
          <div class="attribute-editor-row">
            <div
              class="form-group has-feedback"
              [ngClass]="{ 'has-error': outlookGroupsFailed }"
            >
              <label>Calendar Group</label>
              <select
                class="form-control"
                id="te-outlook-group-id"
                name="te-outlook-group-id"
                [(ngModel)]="selectedOutlookGroup"
                (ngModelChange)="selectedOutlookGroupChanged()"
              >
                <option value="" [shown]="false">Select Group</option>
                @for (g of outlookGroups; track g.id) {
                  <option [value]="g.id">{{ g.name }}</option>
                }
              </select>
              @if (outlookGroupsFailed) {
                <p class="help-block">
                  <span
                    >We couldn't load your Outlook calendar groups. Try again.
                    If the issue continues, contact support.</span
                  >
                </p>
              }
            </div>
          </div>
          <div class="attribute-editor-row">
            <div
              class="form-group has-feedback"
              [ngClass]="{ 'has-error': calendarsFailed }"
            >
              <label id="te-outlook-calendar-id-label">Calendar</label>
              <multi-select-dropdown
                triggerId="te-outlook-calendar-id"
                ariaLabelledBy="te-outlook-calendar-id-label te-outlook-calendar-id"
                triggerText="Add Calendar"
                [items]="calendarDropdownItems"
                [selectedIds]="selectedCalendarIds"
                [open]="calendarPickerOutlookOpen"
                (openChange)="onOutlookCalendarDropdownOpenChange($event)"
                (selectionToggle)="toggleCalendarSelection($event)"
              ></multi-select-dropdown>
              @if (calendarsFailed) {
                <p class="help-block">
                  <span
                    >We couldn't load your calendars. Try again. If the issue
                    continues, contact support.</span
                  >
                </p>
              }
              <multi-select-pills
                [items]="selectedCalendarPillItems"
                (remove)="toggleCalendarSelection($event)"
                class="mt-2"
              ></multi-select-pills>
            </div>
          </div>
        }

        @if (
          provider === PROVIDER_OUTLOOK_CALENDAR &&
          (!sameAccount || !componentAccountUsername) &&
          !isPublicUrl()
        ) {
          <div class="attribute-editor-row">
            <div class="form-group has-feedback">
              <label>Calendar</label><br />
              <multi-select-pills
                [items]="selectedCalendarPillItems"
                (remove)="toggleCalendarSelection($event)"
                class="mt-2"
              ></multi-select-pills>
            </div>
          </div>
        }

        <div class="attribute-editor-row">
          <label>Date Range</label>
          <div
            class="has-feedback"
            [ngClass]="{
              'has-error': !isValidRange(),
              'has-success': isValidRange() && range,
            }"
          >
            <div class="flex-row">
              <input
                type="number"
                class="form-control mr-2"
                id="te-calendar-range"
                name="te-calendar-range"
                placeholder="Range"
                [(ngModel)]="range"
                [min]="rangeMin"
                [max]="rangeMax"
                (ngModelChange)="rangeChanged()"
                aria-label="Date range value"
              />
              <select
                class="form-control"
                id="te-calendar-period"
                name="te-calendar-period"
                [(ngModel)]="period"
                (ngModelChange)="periodChanged()"
                aria-label="Date range period"
              >
                <option value="days">Days</option>
                <option value="weeks">Weeks</option>
                <option value="months">Months</option>
              </select>
            </div>
            @if (!isValidRange()) {
              <p class="help-block">
                <span
                  >Please provide a number between {{ rangeMin }} and
                  {{ rangeMax }}.</span
                >
              </p>
            }
          </div>
        </div>
        <div class="attribute-editor-row" *ngIf="descriptionIsVisible">
          <div class="flex-row left-right-aligner pt-3 form-group">
            <label
              id="calendar-show-description-label"
              class="mb-0 control-label"
              >Show Description</label
            >
            <mat-slide-toggle
              class="pl-3"
              [checked]="showDescription"
              (change)="showDescription = $event.checked; save()"
              [attr.aria-labelledby]="'calendar-show-description-label'"
            ></mat-slide-toggle>
          </div>
        </div>
        <div class="attribute-editor-row" *ngIf="locationIsVisible">
          <div class="flex-row left-right-aligner pt-3 form-group">
            <label id="calendar-show-location-label" class="mb-0 control-label"
              >Show Location</label
            >
            <mat-slide-toggle
              class="pl-3"
              [checked]="showLocation"
              (change)="showLocation = $event.checked; save()"
              [attr.aria-labelledby]="'calendar-show-location-label'"
            ></mat-slide-toggle>
          </div>
        </div>
        <div class="attribute-editor-row">
          <div class="flex-row left-right-aligner pt-3">
            <label
              for="te-calendar-completed"
              id="calendar-completed-label"
              class="mb-0 control-label"
              >Show Completed Events</label
            >
            <mat-slide-toggle
              id="te-calendar-completed"
              class="pl-3"
              [checked]="showCompleted"
              (change)="showCompleted = $event.checked; save()"
              ariaLabelledby="calendar-completed-label"
            ></mat-slide-toggle>
          </div>
        </div>
      }
    </div>
  </div>
</div>
